
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'ホーム', href: '#home' },
    { name: 'サービス', href: '#services' },
    { name: 'キャスト', href: '#cast' },
    { name: 'システム', href: '#system' },
    { name: 'アクセス', href: '#access' },
    { name: 'お問い合わせ', href: '#contact' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-sm' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/efb126a658386e4be9bce47e295892e3.png"
              alt="ATENA"
              className="h-10 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <div className="flex items-baseline space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-white hover:text-blue-400 px-3 py-2 text-sm font-medium transition-colors duration-300 cursor-pointer"
                >
                  {item.name}
                </a>
              ))}
            </div>
            <div className="flex items-center space-x-4 ml-6 pl-6 border-l border-gray-600">
              <a
                href="#"
                className="text-white hover:text-blue-400 transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="text-white hover:text-blue-400 transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-blue-400 cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-sm">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-white hover:text-blue-400 block px-3 py-2 text-base font-medium transition-colors duration-300 cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
            <div className="flex items-center space-x-4 px-3 py-2 border-t border-gray-600 mt-2 pt-4">
              <a
                href="#"
                className="text-white hover:text-blue-400 transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="text-white hover:text-blue-400 transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
